<div class="yourcall-icon-wrapper big-icon" data-crlat="yourcallIcon">
    <svg class="yourcall-label">
        <use xlink:href="#yourcall-icon"></use>
    </svg>
</div>
